export { InvNormLabComponent } from './inv-norm-lab.component';
export type { InvNormLabParams } from './inv-norm-lab.component';
export * from './inv-norm-lab.presets';
